/*
 * OfferPrice Messages
 *
 * This contains all the text for the OfferPrice container.
 */
import { defineMessages } from 'react-intl';
import configs from "configs"

export const scope = 'app.components.OfferPrice';

export default defineMessages({
  price: {
    id: `${scope}.price`,
    defaultMessage: configs.messages[scope].price,
  },
  details: {
    id: `${scope}.details`,
    defaultMessage:  'Offerta soggetta ad esaurimento',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:  'Canone mensile',
  },

});
